// TODO: rename EditWorkflowState
import { useMemo } from "react"
import dayjs from "dayjs"
import PrimeField from "components/PrimeField/PrimeField"

// styles
import "./State.scss"

const State = ({ state, holdStateIndex, index, handleChange, isLast, teamOptions, type }) => {
  const title = useMemo(() => {
    if (state.is_current) return " - Current State"
    switch (state.status) {
      case "Completed": {
        return " - Completed"
      }
      case "Bypassed": {
        return " - Bypassed"
      }
      default: {
        if (holdStateIndex !== -1 && holdStateIndex < index) {
          return " - Lift hold to change dates of future states. Dates recalculated when hold is lifted"
        }
        return ""
      }
    }
  }, [state])

  const isDisabled = useMemo(() => {
    if (holdStateIndex !== -1) {
      return holdStateIndex <= index
    }

    return false
  }, [holdStateIndex])

  const isBypassed = useMemo(() => {
    if (state.status === "Bypassed") {
      return true
    }
  }, [state.status])

  let startDate = state?.start_state_date
  let endDate = state?.end_state_date
  let goalDays = dayjs(endDate).diff(dayjs(startDate), "day")

  if (goalDays < 0) {
    goalDays = 0
  }

  return (
    <div className="state-item">
      <div className="state-item-header">
        {state.state_title}&nbsp; <p className="state-status">{title}</p>
      </div>
      <div className="state-inputs">
        <div className="column">
          <div className="title">
            <>
              Start date
              {index > 0 && (
                <>
                  <br />
                  (previous end date)
                </>
              )}
            </>
          </div>
          <div style={{ width: 160 }}>
            <PrimeField
              schema={{
                type: "date",
              }}
              disabled={index !== 0 || isDisabled || isBypassed}
              onChange={(val) => handleChange("start_state_date", val, index)}
              value={startDate}
            />
          </div>
        </div>
        <div className="column">
          {!isLast && (
            <>
              <div className="title">End date</div>
              <div style={{ width: 160 }}>
                <PrimeField
                  schema={{
                    type: "date",
                  }}
                  disabled={isDisabled || isBypassed}
                  onChange={(val) => handleChange("end_state_date", val, index)}
                  value={endDate}
                />
              </div>
            </>
          )}
        </div>
        <div className="column">
          {!isLast && (
            <>
              <div className="title">Duration (Days)</div>
              <div className="content">
                <PrimeField
                  schema={{
                    type: "number",
                  }}
                  min={0}
                  disabled={isDisabled || isBypassed}
                  onChange={(val) => handleChange("goal_days", val, index)}
                  value={goalDays}
                />
              </div>
            </>
          )}
        </div>
        <div
          className="column assignees-col"
          style={{ marginLeft: isLast && 251 }}
        >
          <div className="title">Assignee</div>
          <div className="content">
            <PrimeField
              schema={{
                type: "multiselect",
                placeholder: "Select assignee",
                items: teamOptions || [],
              }}
              tooltip={teamOptions.length === 0 && `To make selection, first add team members to the ${type}`}
              disabled={isDisabled || teamOptions.length === 0}
              value={state?.assigned_to_ids?.filter((id) => teamOptions.find((user) => user.value === id))}
              onChange={(val) => handleChange("assigned_to_ids", val, index)}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default State
